import Layout from 'components/layout/Layout'
import React from 'react'
import { Navigate, useParams, useMatch } from 'react-router-dom'
import PropTypes from 'prop-types'
import { toast } from 'react-toastify'
import CustomToast from 'components/common/custom-toast/CustomToast'
import { alertTypes } from 'constants/Common'
import {
  getUserInfoFromStorage,
  isAdminPortalUser,
  removeAccessToken,
  removeUserInfoFromStorage,
} from 'utils/common'

function Protected({ isLoggedIn, children }) {
  const match = useMatch('/eventsattended/:QRToken')
  const selectEventMatch = useMatch('/select-event')
  const { id } = useParams()

  if (isLoggedIn) {
    const user = getUserInfoFromStorage()
    if (user && !isAdminPortalUser(user)) {
      removeAccessToken()
      removeUserInfoFromStorage()
      toast(
        <CustomToast
          variant={alertTypes.DANGER}
          message='Only admins have access to the portal.'
        />
      )
      return <Navigate to='/' replace />
    }
  }

  if (!isLoggedIn) {
    if (match) {
      return <Navigate to={`/?eventsattended=${id}`} replace />
    }
    return <Navigate to='/' replace />
  }
  if (match || selectEventMatch) return children
  return <Layout>{children}</Layout>
}
Protected.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
}
export default Protected
